import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '@core/auth/auth-guard.service';
import { RouteAction } from '@core/action/action';
import { EntidadeListComponent } from './pages/entidade-list/entidade-list.component';
import { EntidadeFormComponent } from './pages/entidade-form/entidade-form.component';
import { RoleEnum } from '@core/models/role';
import { PerfilEnum } from '@core/models/perfil';

const routes: Routes = [

  {
    path: '',
    component: EntidadeListComponent,
    canActivate: [AuthGuardService],
    data: {
       acao: RouteAction.Visualizar,
      headerPage: {
        titlePage: '',
        subTitlePage: '',
      },
      permissions: {
         only: [RoleEnum.EntidadeLeitura, PerfilEnum.Administrador, PerfilEnum.Validador],
         redirectTo: '/acessoNaoPermitido'
      }
    },
  },
  {
    path: 'cadastrar',
    component: EntidadeFormComponent,
    data: {
      acao: RouteAction.Inserir,
      headerPage: {
        titlePage: 'Cadastro',
        subTitlePage: 'Entidades',
      },
      permissions: {
         only: [RoleEnum.EntidadeGravacao, PerfilEnum.Administrador, PerfilEnum.Validador],
         redirectTo: '/acessoNaoPermitido'
      }
    },
  },
  {
    path: 'editar/:id',
    component: EntidadeFormComponent,
    data: {
      acao: RouteAction.Editar,
      headerPage: {
        titlePage: 'Edição',
        subTitlePage: 'Entidades',
      },
      permissions: {
         only: [RoleEnum.EntidadeEdicao,PerfilEnum.Administrador, PerfilEnum.Validador],
         redirectTo: '/acessoNaoPermitido'
      }
    },
  },
  {
    path: 'visualizar/:id',
    component: EntidadeFormComponent,
    data: {
      acao: RouteAction.Visualizar,
      headerPage: {
        titlePage: 'Visualizar',
        subTitlePage: 'Usuário',
      },
      permissions: {
         only: [RoleEnum.EntidadeLeitura,PerfilEnum.Administrador, PerfilEnum.Validador],
         redirectTo: '/acessoNaoPermitido'
      }
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EntidadeRoutingModule { }
